// File: Login.jsx
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FaGithub } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import api from "../Utils/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import Spinner from "../Components/Spinner";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (!email || !password) {
      toast.info("Please fill in all fields");
      return;
    }
    const res = await api.post("/user/login", { email, password, web: true });
    setIsLoading(false);
    if (res.data.success) {
      toast.success(res.data.message);

      localStorage.setItem("token", res.data.token);
      let decoded = jwtDecode(res.data.token);
      dispatch({ type: "SET_USER", payload: decoded });
      navigate("/");
    } else {
      toast.error(res.data.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white relative px-4">
      {isLoading && <Spinner />}

      {/* Content Wrapper */}
      <div className="relative z-10 flex flex-col -mt-24 items-center w-full max-w-md">
        {/* Title */}
        <div className="mb-8">
          <h1 className="font-extrabold text-[30px] md:text-5xl text-red-600 text-center tracking-wide">
            ALERTLINE ROSTER
          </h1>
        </div>

        {/* Login Card */}
        <div className="w-full rounded-xl shadow-lg bg-white p-8 border border-gray-200">
          <h2
            className="text-3xl font-bold text-gray-700 mb-6"
            style={{ fontFamily: "Righteous, sans-serif" }}
          >
            Login
          </h2>
          <form onSubmit={handleLogin} className="space-y-5 text-gray-700">
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-1">
                Email address
              </label>
              <input
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                className="w-full px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
                required
                autoComplete="email"
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium mb-1"
              >
                Password
              </label>
              <input
                onChange={(e) => setPassword(e.target.value)}
                id="password"
                type="password"
                className="w-full px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
                required
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-gray-600 text-white py-2 rounded-md font-semibold hover:bg-gray-700 transition"
            >
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
